import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";

const StatsSection = ({ data }) => {
  return (
    <div className="bg-[#F5F5F58A] p-6 rounded-[1.75rem] shadow-sm">
      <div className="flex justify-between items-center mb-6">
        <h3 className="font-nunito font-bold text-2xl leading-none">
          Quotations Stats
        </h3>
        <select className="border rounded-lg px-3 py-1 text-sm">
          <option>2020</option>
          <option>2021</option>
          <option>2022</option>
        </select>
      </div>

      <div className="h-[400px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="name" />
            <YAxis />
            <Bar dataKey="total" fill="#173363" />
            <Bar dataKey="approved" fill="#5BC4FF" />
            <Bar dataKey="pending" fill="#07DBFA" />
            <Bar dataKey="pending" fill="#071B35" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default StatsSection;
